import React, { Component } from "react";
import Slider from "react-slick";
import IcoConsulting from "../../assets/solution_icon/ico_consulting.svg";
import IcoOutils from "../../assets/solution_icon/ico_outils.svg"
import IcoEdition from "../../assets/solution_icon/ico_edition.svg"
import IcoRecherche from "../../assets/solution_icon/ico_recherche.svg";
import "./carouselSolution.css";
import ReactSVG from 'react-svg'

export default class CarouselSolutionResponsive extends Component {
  render() {
    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 3,
      arrows: false,
      responsive: [
        {
          breakpoint: 1045,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: true,
            dots: true,
            arrows: false
          }
        },
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            initialSlide: 2,
            arrows: false
          }
        }
      ]
    };
    return (
      <div className="backCarouselSolution">
        <Slider {...settings}>

          <div style={{ width: "35%" }}>
            <div style={{ padding: "5%" }}>
              <div style={{ display: "flex", width: "100%" }}>
                <div>
                  <ReactSVG style={{ width: "50px" }}  src={IcoEdition} />
                </div>
                <div style={{marginLeft:"2%"}}>
                  <h3 style={{ color: "#3d3d3d", fontFamily: "Oswald", fontSize: "18px" }}>EDITION DE SOLUTION</h3>
                </div>
              </div>
              <div>
                <p style={{ color: "#58585b", fontFamily: "Open Sans", textAlign: "justify", fontSize: "15px", lineHeight: "25px" }}>
                  Nous concevons des solutions innovantes spécifiques aux besoins de nos clients entreprises,
                      quel que soit le secteur d’activité.
  </p>
              </div>
            </div>
          </div>




          <div style={{ width: "35%" }}>
            <div style={{ padding: "5%" }}>
              <div style={{ display: "flex", width: "100%" }}>
                <div>
                  <ReactSVG style={{ width: "50px" }}  src={IcoConsulting} />
                </div>
                <div style={{marginLeft:"2%"}}>
                  <h3 style={{ color: "#3d3d3d", fontFamily: "Oswald", fontSize: "18px" }}>CONSULTING & BUSINESS INTELLIGENCE</h3>
                </div>
              </div>
              <div>
                <p style={{ color: "#58585b", fontFamily: "Open Sans", textAlign: "justify", fontSize: "15px", lineHeight: "25px" }}>
                  Nous proposons un accompagnement personnalisé
                  pour les projets stratégiques et novateurs de nos clients.
                </p>
              </div>
            </div>
          </div>




          <div style={{ width: "35%" }}>
            <div style={{ padding: "5%" }}>
              <div style={{ display: "flex", width: "100%" }}>
                <div>
                  <ReactSVG style={{ width: "50px" }} src={IcoOutils} />
                </div>
                <div style={{marginLeft:"2%"}}>
                  <h3 style={{ color: "#3d3d3d", fontFamily: "Oswald", fontSize: "18px" }}>OUTILS DIGITAUX</h3>
                </div>
              </div>
              <div>
                <p style={{ color: "#58585b", fontFamily: "Open Sans", textAlign: "justify", fontSize: "15px", lineHeight: "25px" }}>
                  Nous concevons des outils digitaux de visibilité qui permettent
                  de rapidement développer un business et fidéliser les clients.
                </p>
              </div>
            </div>
          </div>
          
          <div style={{ width: "35%" }}>
            <div style={{ padding: "5%" }}>
              <div style={{ display: "flex", width: "100%" }}>
                <div>
                  <ReactSVG style={{ width: "50px",height:"40px" }} src={IcoRecherche}  />
                </div>
                <div style={{marginLeft:"2%"}}>
                  <h3 style={{ color: "#3d3d3d", fontFamily: "Oswald", fontSize: "18px" }}>RECHERCHE & DÉVELOPPEMENT</h3>
                </div>
              </div>
              <div>
                <p style={{ color: "#58585b", fontFamily: "Open Sans", textAlign: "justify", fontSize: "15px", lineHeight: "25px" }}>
                  Nous aidons les entreprises à définir leurs stratégies d’innovation, à monter,
                  piloter et coordonner leurs différents projets R&D.
                </p>
              </div>
            </div>
          </div>
        </Slider>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/home/responsive/carouselSolution.js